const booking = {
  namespaced: true,
  state: {
    planInfo: {},
    productInfo: {},
    formProductInfo: {},

    userInfo: {},
  },
  mutations: {
    setPlanInfo(state, planInfo) {
      state.planInfo = planInfo;
    },
    setProductInfo(state, productInfo) {
      state.productInfo = productInfo;
    },
    setFormProductInfo(state, formProductInfo) {
      state.formProductInfo = formProductInfo;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit("setUserInfo", userInfo);
    },
    setPlanInfo({ commit }, planInfo) {
      commit("setPlanInfo", planInfo);
    },
    setProductInfo({ commit }, productInfo) {
      commit("setProductInfo", productInfo);
    },
    setFormProductInfo({ commit }, formProductInfo) {
      commit("setFormProductInfo", formProductInfo);
    },
  },
};

export default booking;
